import type { HoneycombTileData } from './honeycomb.js';
import type { TileColorMetadata } from './rendering.js';
import type { LegendItem } from '../../core/components/legend/categorical/types/legend.js';
import type { Point } from '../../core/types/point.js';

export interface HoneycombOverlayState {
  mouseInBounds: boolean;
}

export interface HoneycombTooltipState {
  enabled: boolean;
  visible: boolean;
  pinned: boolean;
  tileData?: HoneycombTileData;
  colorMetadata?: TileColorMetadata;
  position?: Point;
}

export interface HoneycombSelectionState {
  hovered: LegendItem | undefined;
}

export interface HoneycombState {
  tooltip: HoneycombTooltipState;
  selection: HoneycombSelectionState;
  overlay: HoneycombOverlayState;
}

export const initialState: HoneycombState = {
  tooltip: {
    enabled: true,
    pinned: false,
    visible: false,
  },
  selection: {
    hovered: undefined,
  },
  overlay: {
    mouseInBounds: false,
  },
};
